/**
 * The Search chord, on its own so the one rule can be tested without the
 * search surface around it (components/workspace/search-everything.tsx is
 * its only caller).
 */

/**
 * Is this keydown the Search chord, ⌘K (Ctrl K off a Mac)?
 *
 * NOT WITH SHIFT (2026-10-03). ⌘⇧K is Discover's chord, handled by the rail
 * (workspace-rail.tsx, "The plain ⌘K palette is untouched"). This test did
 * not look at Shift, so the one keydown ran both: Discover opened and the
 * Search panel opened underneath it. Closing Discover then left a Search
 * panel nobody had asked for, over a full-screen app it covered the bar's
 * name, and with the Account panel open the chord swapped its content for
 * Search (the browser pass of 2026-10-03 saw all three).
 * tests/unit/workspaces/search-chord-not-with-shift.test.ts
 */
export function isSearchChord(e: Pick<KeyboardEvent, 'metaKey' | 'ctrlKey' | 'shiftKey' | 'key'>): boolean {
  return (e.metaKey || e.ctrlKey) && !e.shiftKey && (e.key === 'k' || e.key === 'K');
}
